/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Work Plan View Diagram Filter Type
 */
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export type WorkPlanViewDiagramFilterTypeEnum = 'Results Chains Only' | 'Situation Models Only' | 'Both Situation Models and Results Chains';

export const WorkPlanViewDiagramFilterTypeEnum = {
    ResultsChainsOnly: 'Results Chains Only' as WorkPlanViewDiagramFilterTypeEnum,
    SituationModelsOnly: 'Situation Models Only' as WorkPlanViewDiagramFilterTypeEnum,
    BothSituationModelsAndResultsChains: 'Both Situation Models and Results Chains' as WorkPlanViewDiagramFilterTypeEnum
};

marker('Results Chains Only');
marker('Situation Models Only');
marker('Both Situation Models and Results Chains');

